"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockCategory = exports.CATEGORY_PREFIX = exports.SUBCATEGORY_PREFIX = void 0;
const subcategory_1 = require("./subcategory");
exports.SUBCATEGORY_PREFIX = 'SUBCATEGORY::';
exports.CATEGORY_PREFIX = 'CATEGORY::';
function mockCategory(overrides = {}) {
    return {
        banner_image: 'http://example.com/banner_image.jpg',
        description: '<p>mock description</p>',
        display_name: 'mock display_name',
        display_order: 4,
        id: 1,
        image: 'http://example.com/image.jpg',
        img_alt: 'mock img_alt',
        meta_description: 'mock meta_description',
        meta_title: 'mock meta_title',
        name: 'hardbaits',
        page_heading: 'mock page_heading',
        page_subheading: 'mock page_subheading',
        subcategories: [(0, subcategory_1.mockSubcategory)()],
        url_path: 'mock_url_path',
        ...overrides,
    };
}
exports.mockCategory = mockCategory;
